import { navigator } from 'global';

import { NETWORK_STATUS } from 'actions/network';

const initialState = {
  status: navigator.onLine,
};

export default function network(state = initialState, action) {
  switch (action.type) {
    case NETWORK_STATUS:
      return {
        ...state,
        status: action.status,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/network.js